"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isCancellationError(error) {
    return ['backdrop', 'overlay', 'cancel', 'close', 'esc', 'timer'].indexOf(error) !== -1;
}
exports.default = isCancellationError;
